import { gql } from '@apollo/client';

const STOP_CHARGING_SESSION = {
  mutation: gql`
    mutation StopChargingSession($sessionId: String) {
      stopChargingSession(sessionId: $sessionId) {
        connectorId
        _id
        active
        status
        vehiclePlate
        providerSessionId
        providerId
      }
    }
  `,
  policies: {
    errorPolicy: 'all',
  },
};

export default STOP_CHARGING_SESSION;
